// // import { motion } from "framer-motion";
// // import { ArrowRight, CalendarDays, Clock, Newspaper, Rss, Tag } from "lucide-react";

// // export default function NewsCard({ item, index = 0, showSource = false }) {
// //   return (
// //     <motion.article
// //       initial={{ opacity: 0, y: 26 }}
// //       animate={{ opacity: 1, y: 0 }}
// //       exit={{ opacity: 0, y: -14 }}
// //       transition={{ duration: 0.45, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
// //       className="group relative"
// //     >
// //       <div className="flex flex-col sm:flex-row gap-5 sm:gap-7 py-7 sm:py-8">
// //         {/* thumbnail */}
// //         <div className="relative shrink-0 sm:w-[228px]">
// //           <div className="relative overflow-hidden rounded-2xl ring-1 ring-ink/10 shadow-[0_16px_34px_-18px_rgba(34,21,16,0.35)] aspect-[16/10] sm:aspect-auto sm:h-[142px]">
// //             <img
// //               src={item.image}
// //               alt={item.title}
// //               loading="lazy"
// //               className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.08]"
// //             />
// //             <div className="absolute inset-0 bg-gradient-to-t from-deeprose/35 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-opacity duration-500" />
// //             <span className="absolute top-2.5 left-2.5 inline-flex items-center gap-1.5 rounded-full bg-white/95 backdrop-blur px-2.5 py-1 text-[9.5px] font-extrabold uppercase tracking-[0.14em] text-brand shadow">
// //               <Rss className="w-3 h-3" />
// //               {item.type}
// //             </span>
// //           </div>
// //         </div>

// //         {/* body */}
// //         <div className="min-w-0 flex-1">
// //           <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] font-extrabold uppercase tracking-[0.16em] text-mute">
// //             <span className="text-ember">{item.type}</span>
// //             <span className="w-1 h-1 rounded-full bg-mute/50" />
// //             <span className="inline-flex items-center gap-1.5">
// //               <CalendarDays className="w-3.5 h-3.5" /> {item.displayDate}
// //             </span>
// //             {showSource && item.source && (
// //               <>
// //                 <span className="w-1 h-1 rounded-full bg-mute/50" />
// //                 <span className="inline-flex items-center gap-1.5 text-ink/55">
// //                   <Newspaper className="w-3.5 h-3.5" /> {item.source}
// //                 </span>
// //               </>
// //             )}
// //           </p>

// //           <h3 className="mt-2.5">
// //             <a
// //               href="#"
// //               onClick={(e) => e.preventDefault()}
// //               className="text-[19px] sm:text-[21px] font-display font-semibold leading-[1.25] text-brand decoration-ember decoration-[2.5px] underline-offset-[5px] group-hover:underline group-hover:text-deeprose transition-colors"
// //             >
// //               {item.title}
// //             </a>
// //           </h3>

// //           <p className="mt-2.5 text-[13.5px] leading-relaxed text-ink/65 line-clamp-2 max-w-3xl">
// //             {item.excerpt}
// //           </p>

// //           <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2.5">
// //             <span className="inline-flex items-center gap-1.5 text-[12px] font-bold text-mute">
// //               {/* <Clock className="w-3.5 h-3.5" /> {item.readMins} min read */}
// //             </span>

// //             <span className="hidden sm:flex items-center gap-1.5">
// //               {item.subjects.slice(0, 2).map((s) => (
// //                 <span
// //                   key={s}
// //                   className="inline-flex items-center gap-1 rounded-full bg-blush ring-1 ring-brand/15 px-2.5 py-1 text-[10.5px] font-bold text-deeprose/80"
// //                 >
// //                   <Tag className="w-2.5 h-2.5" /> {s}
// //                 </span>
// //               ))}
// //             </span>

// //             <a
// //               href="#"
// //               onClick={(e) => e.preventDefault()}
// //               className="ml-auto inline-flex items-center gap-1.5 text-[12px] font-extrabold text-crimson hover:text-deeprose transition-colors"
// //             >
// //               Read full story
// //               <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
// //             </a>
// //           </div>
// //         </div>
// //       </div>

// //       {/* divider */}
// //       <div className="h-px bg-gradient-to-r from-transparent via-brand/20 to-transparent" />
// //     </motion.article>
// //   );
// // }




// // new new code 




// import { motion } from "framer-motion";
// import { ArrowRight, CalendarDays, Newspaper, Tag } from "lucide-react";

// function getDateParts(item) {
//   const raw = item.date || item.displayDate;
//   const parsed = raw ? new Date(raw) : null;

//   if (parsed && !isNaN(parsed.getTime())) {
//     return {
//       day: parsed.getDate(),
//       month: parsed.toLocaleString("en-US", { month: "short" }).toUpperCase(),
//       year: parsed.getFullYear(),
//     };
//   }
//   return { day: null, month: null, year: null };
// }

// export default function NewsCard({ item, index = 0, showSource = false }) {
//   const { day, month, year } = getDateParts(item);

//   return (
//     <motion.article
//       initial={{ opacity: 0, y: 26 }}
//       animate={{ opacity: 1, y: 0 }}
//       exit={{ opacity: 0, y: -14 }}
//       transition={{ duration: 0.45, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
//       className="group relative"
//     >
//       <div className="flex flex-row gap-5 sm:gap-7 py-7 sm:py-8">
//         {/* date block */}
//         {/* <div className="relative shrink-0 w-[78px] sm:w-[104px]">
//           <div className="relative flex flex-col items-center justify-center h-[92px] sm:h-[142px] overflow-hidden rounded-2xl ring-1 ring-brand/15 bg-gradient-to-br from-blush via-white to-blush shadow-[0_16px_34px_-18px_rgba(34,21,16,0.35)] transition-transform duration-500 group-hover:-translate-y-0.5">
//             <span className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-ember via-crimson to-deeprose" />

//             {day ? (
//               <>
//                 <span className="font-display text-[32px] sm:text-[40px] font-extrabold leading-none text-brand tracking-tight transition-colors duration-300 group-hover:text-deeprose">
//                   {day}
//                 </span>
//                 <span className="mt-2 text-[10px] sm:text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-crimson">
//                   {month} &middot; {year}
//                 </span>
//               </>
//             ) : (
//               <span className="px-2 text-center text-[11px] font-extrabold uppercase tracking-[0.14em] text-crimson">
//                 {item.displayDate}
//               </span>
//             )}
//           </div>
//         </div> */}

//         {/* body */}
//         <div className="min-w-0 flex-1">
//           <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[12.5px] font-extrabold uppercase tracking-[0.16em] text-mute">
//             {/* <span className="text-ember">{item.type}</span> */}
//             <span className="w-1 h-1 rounded-full bg-mute/50" />
//             <span className="inline-flex items-center gap-1.5">
//               <CalendarDays className="w-3.5 h-3.5" /> {item.displayDate}
//             </span>
//             {showSource && item.source && (
//               <>
//                 <span className="w-1 h-1 rounded-full bg-mute/50" />
//                 <span className="inline-flex items-center gap-1.5 text-ink/55">
//                   <Newspaper className="w-3.5 h-3.5" /> {item.source}
//                 </span>
//               </>
//             )}
//           </p>

//           <h3 className="mt-2.5">
//             <a
//               href="#"
//               onClick={(e) => e.preventDefault()}
//               className="text-[19px] sm:text-[21px] font-display font-semibold leading-[1.25] text-brand decoration-ember decoration-[2.5px] underline-offset-[5px] group-hover:underline group-hover:text-deeprose transition-colors"
//             >
//               {item.title}
//             </a>
//           </h3>

//           <p className="mt-2.5 text-[13.5px] leading-relaxed text-ink/65 line-clamp-2 max-w-3xl">
//             {item.excerpt}
//           </p>

//           <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2.5">
//             <span className="hidden sm:flex items-center gap-1.5">
//               {item.subjects.slice(0, 2).map((s) => (
//                 <span
//                   key={s}
//                   className="inline-flex items-center gap-1 rounded-full bg-blush ring-1 ring-brand/15 px-2.5 py-1 text-[10.5px] font-bold text-deeprose/80"
//                 >
//                   <Tag className="w-2.5 h-2.5" /> {s}
//                 </span>
//               ))}
//             </span>

//             <a
//               href="#"
//               onClick={(e) => e.preventDefault()}
//               className="ml-auto inline-flex items-center gap-1.5 text-[12px] font-extrabold text-crimson hover:text-deeprose transition-colors"
//             >
//               Read full story
//               <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* divider */}
//       <div className="h-px bg-gradient-to-r from-transparent via-brand/20 to-transparent" />
//     </motion.article>
//   );
// }





// new new code 





import { motion } from "framer-motion";
import { ArrowRight, CalendarDays, Newspaper, Tag } from "lucide-react";

function getDateParts(item) {
  const raw = item.date || item.displayDate;
  const parsed = raw ? new Date(raw) : null;

  if (parsed && !isNaN(parsed.getTime())) {
    return {
      day: parsed.getDate(),
      month: parsed.toLocaleString("en-US", { month: "short" }).toUpperCase(),
      year: parsed.getFullYear(),
    };
  }
  return { day: null, month: null, year: null };
}

export default function NewsCard({ item, index = 0, showSource = false }) {
  const { day, month, year } = getDateParts(item);

  return (
    <motion.article
      initial={{ opacity: 0, y: 26 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -14 }}
      transition={{ duration: 0.45, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className="group relative mb-5 sm:mb-6 last:mb-0"
    >
      <div className="relative overflow-hidden rounded-2xl bg-[#ffffff] ring-1 ring-black/5 shadow-[0_14px_40px_-24px_rgba(20,20,25,0.25)] px-5 py-6 sm:px-7 sm:py-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_22px_50px_-24px_rgba(180,35,24,0.28)] hover:ring-brand/20">
        {/* accent line — reveals on hover */}
        <span className="absolute inset-x-0 top-0 h-[3px] origin-left scale-x-0 bg-gradient-to-r from-crimson via-brand to-ember transition-transform duration-500 group-hover:scale-x-100" />

        <div className="flex flex-row gap-5 sm:gap-7">
          {/* date block */}
          {/* <div className="relative shrink-0 w-[78px] sm:w-[104px]">
            <div className="relative flex flex-col items-center justify-center h-[92px] sm:h-[142px] overflow-hidden rounded-2xl ring-1 ring-brand/15 bg-gradient-to-br from-blush via-white to-blush shadow-[0_16px_34px_-18px_rgba(34,21,16,0.35)] transition-transform duration-500 group-hover:-translate-y-0.5">
              <span className="absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r from-ember via-crimson to-deeprose" />

              {day ? (
                <>
                  <span className="font-display text-[32px] sm:text-[40px] font-extrabold leading-none text-brand tracking-tight transition-colors duration-300 group-hover:text-deeprose">
                    {day}
                  </span>
                  <span className="mt-2 text-[10px] sm:text-[10.5px] font-extrabold uppercase tracking-[0.18em] text-crimson">
                    {month} &middot; {year}
                  </span>
                </>
              ) : (
                <span className="px-2 text-center text-[11px] font-extrabold uppercase tracking-[0.14em] text-crimson">
                  {item.displayDate}
                </span>
              )}
            </div>
          </div> */}

          {/* body */}
          <div className="min-w-0 flex-1">
            <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-[12.5px] font-extrabold uppercase tracking-[0.16em] text-mute">
              {/* <span className="text-ember">{item.type}</span> */}
              <span className="inline-flex items-center gap-1.5">
                <CalendarDays className="w-3.5 h-3.5" /> {item.displayDate}
              </span>
              {showSource && item.source && (
                <>
                  <span className="w-1 h-1 rounded-full bg-mute/50" />
                  <span className="inline-flex items-center gap-1.5 text-ink/55">
                    <Newspaper className="w-3.5 h-3.5" /> {item.source}
                  </span>
                </>
              )}
            </p>

            <h3 className="mt-2.5">
              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="text-[19px] sm:text-[21px] font-display font-semibold leading-[1.25] text-brand decoration-ember decoration-[2.5px] underline-offset-[5px] group-hover:underline group-hover:text-deeprose transition-colors"
              >
                {item.title}
              </a>
            </h3>

            <p className="mt-2.5 text-[13.5px] leading-relaxed text-ink/65 line-clamp-2 max-w-3xl">
              {item.excerpt}
            </p>

            <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2.5">
              <span className="hidden sm:flex items-center gap-1.5">
                {item.subjects.slice(0, 2).map((s) => (
                  <span
                    key={s}
                    className="inline-flex items-center gap-1 rounded-full bg-blush ring-1 ring-brand/15 px-2.5 py-1 text-[10.5px] font-bold text-deeprose/80"
                  >
                    <Tag className="w-2.5 h-2.5" /> {s}
                  </span>
                ))}
              </span>

              <a
                href="#"
                onClick={(e) => e.preventDefault()}
                className="ml-auto inline-flex items-center gap-1.5 text-[12px] font-extrabold text-crimson hover:text-deeprose transition-colors"
              >
                Read full story
                <ArrowRight className="w-3.5 h-3.5 transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.article>
  );
}